<kendo-grid [data]="actionItems" id="action-items-grid" [rowClass]="rowCallback" scrollable="none">
    <kendo-grid-column field="status" title="Status" [width]="100">
        <ng-template kendoGridCellTemplate let-item>
            <kendo-badge class="!k-pos-relative !k-translate-0 !k-z-0 semibold-text" size="medium" themeColor="none"
                [ngClass]="getClasses(item?.status)">
                {{ getStatus(item?.status) }}
            </kendo-badge>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="actionRequired" title="Action Required" [width]="250">
        <ng-template kendoGridCellTemplate let-item>
            <p class="semibold-text k-m-0">{{ item?.name }}</p>
            <p class="k-m-0 secondary">
                @if (item?.id) {
                <span>ID: </span><span>{{ item?.id }}</span>
                }
                @if (item?.ihmsCaseNo) {
                <span> | IHMS Case No: </span><span>{{ item?.ihmsCaseNo }}</span>
                }
            </p>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="type" title="Type" [width]="150">
        <ng-template kendoGridCellTemplate let-item>
            <p class="k-white-space-normal">{{ item?.type }}</p>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="details" title="Details">
        <ng-template kendoGridCellTemplate let-item>
            <p class="k-white-space-normal">{{ item?.details }}</p>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assignee" title="Assignee" [width]="150">
        <ng-template kendoGridCellTemplate let-item>
            @if (!item.assigneeName) {
            <div class="k-d-grid k-justify-items-start">
                <span class="k-font-semibold unassigned-label">Unassigned</span>
                @if(item.status !== ihmsStatus.Completed || item.status !== ihmsStatus.Returned){
                <button kendoButton class="assign-btn k-p-0" (click)="displayAssignActionItemDialog(item)"
                    fillMode="link">
                    (Assign)
                </button>
                }
            </div>
            }
            @if(item.assigneeName){
            <div class="k-d-grid k-justify-items-start">
                <p class="!k-my-0">
                    <span>{{item?.assigneeName}}</span>
                    <button class="!k-p-0" [svgIcon]="addressBook" fillMode="flat" kendoButton kendoPopoverAnchor
                        title="Contact" aria-label="Contact" [popover]="addressPopover" size="medium" #popoverAnchor="kendoPopoverAnchor"
                        (click)="popoverAnchor.show()">
                    </button>
                </p>
                @if(item.status !== ihmsStatus.Completed || item.status !== ihmsStatus.Returned){
                <button kendoButton class="assign-btn k-p-0" (click)="displayAssignActionItemDialog(item, true)"
                    fillMode="link">
                    (Reassign)
                </button>

                }
            </div>
            <kendo-popover #addressPopover>
                <ng-template kendoPopoverBodyTemplate>
                    <div class="!k-d-flex k-justify-content-between k-align-items-end">
                        <p style="font-weight: 600;" class="!k-my-0">{{item?.assigneeName}}</p>
                        <button kendoButton fillMode="flat" [svgIcon]="xIcon" size="small"
                            (click)="popoverAnchor.hide()" title="Close" aria-label="Close"></button>
                    </div>
                    <p class="!k-mt-0 !k-mb-3">
                        <span>{{item?.assigne}}</span>
                        <button class="!k-p-1" [svgIcon]="copy" fillMode="flat" kendoButton #anchor kendoTooltip
                            [tooltipTemplate]="template" (mouseover)="tooltipDir.show(anchor)"
                            (focus)="tooltipDir.show(anchor)" (mouseleave)="tooltipDir.hide()"
                            (blur)="tooltipDir.hide()" position="bottom" showOn="none" size="medium"
                            (click)="copyClipboard(item?.assigne)" aria-label="Copy email">
                        </button>
                    </p>
                </ng-template>
                <ng-template #template>
                    <span>{{ tooltipText }}</span>
                </ng-template>
            </kendo-popover>
            }
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Due Date" [width]="200">
        <ng-template kendoGridCellTemplate let-item>
            <p>
                <!---Uncomment below code once API returns compliance status--->
                <!-- @if(item?.complianceStatus === 'At Risk'){
                <fa-icon icon="circle-exclamation" title="At Risk"></fa-icon>
                }
                @if (item?.complianceStatus === 'Out of Compliance') {
                <fa-icon icon="triangle-exclamation" title="Out of compliance"></fa-icon>
                }
                @if(item?.complianceStatus === 'Reason for Delay'){
                <fa-icon icon="hourglass-half" title="Reason for Delay"></fa-icon>
                } -->
                <span>{{item?.dueDate | formatDate}}</span>
                <br />
                <span>
                    ({{ `${item?.daysLeft} ${item?.daysLeft > 1 ? 'Days Left' : 'Day Left'}` }})
                </span>

                <span></span>
            </p>

        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Actions" [width]="150">
        <ng-template kendoGridCellTemplate let-item>
            @if(item.status !== ihmsStatus.Completed || item.status !== ihmsStatus.Returned){
            <div class="k-d-flex k-gap-x-2">
                <button kendoButton [svgIcon]="undoIcon" themeColor="light" kendoTooltip title="Send Back to IHMS"
                    (click)="sendBackToIHMS(item)" aria-label="Send back to IHMS"></button>
                <button kendoButton [svgIcon]="squareCheck" themeColor="primary" kendoTooltip
                    title="Complete Action Item" (click)="completeActionItem(item)" aria-label="Complete action item"></button>
            </div>
            }
        </ng-template>
    </kendo-grid-column>
</kendo-grid>